// import { GatewayTypes } from "@/data/enums";
// import i18n from "@/i18n";

export enum GatewayAuthType {
  NONE = "none",
  SETTINGS = "settings",
  OAUTH2 = "oauth2"
}

export enum GatewayStoreType {
  /**
   * none (gateway does NOT support stored payment details)
   */
  NONE = "none",
  /**
   * either (gateway supports one-off payments + stored payment details)
   */
  EITHER = "either",
  /**
   * always (gateway does NOT support one-off payments; stored payment details only) - this is the case for GoCardless where an agreement (mandate) must be set up first
   */
  ALWAYS = "always"
}

export enum GatewayContext {
  PAY = "pay", // PAY = Gateways are shown in the context of making a payment (invoice, topup etc)
  ADD = "add" // ADD = Gateways are shown in the context of adding a stored payment detail
}

export enum GatewayProviderCodes {
  ADYEN = "Adyen",
  BANK_TRANSFER = "BankTransfer",
  BIT_PAY = "BitPay",
  BLOCKONOMICS = "Blockonomics",
  BRAINTREE = "Braintree",
  COIN_GATE = "CoinGate",
  D_LOCAL = "DLocal",
  FLUTTERWAVE = "Flutterwave",
  FLUTTERWAVE_CARD = "Flutterwave_Card",
  GO_CARDLESS = "GoCardless",
  MERCADO_PAGO = "MercadoPago",
  MERCADO_PAGO_OTHER_PAYMENTS = "MercadoPago_Other_Payments",
  MICROPAYMENT = "Micropayment",
  MOMO_MTN_COLLECTIONS = "MomoMtn_Collections",
  OFFLINE = "Offline",
  OPENPAY = "OpenPay",
  OPENPAY_NON_CARD = "OpenPay_Other_Payments",
  PAYSAFECARD = "Paysafecard",
  PAYSTACK = "Paystack",
  PAYTM = "Paytm",
  PAY_FAST = "PayFast",
  PAYPAL_BILLING_AGREEMENT = "PayPal_BillingAgreement",
  PAYPAL_EXPRESS = "PayPal_Express",
  PAYPAL_LEGACY_SUBSCRIPTION = "PayPalLegacy_Subscription",
  PAYPAL_PRO = "PayPal_Pro",
  PAYPAL_REST = "PayPal_Rest",
  PAYPAL_SUBSCRIPTION_AGREEMENT = "PayPal_SubscriptionAgreement",
  PAY_U = "PayU",
  PESA_PAL = "PesaPal",
  RAZOR_PAY = "RazorPay",
  RAZOR_PAY_CHECKOUT = "RazorPay_Checkout",
  SAGE_PAY_DIRECT = "SagePay_Direct",
  SSL_COMMERZ = "SSLCommerz",
  STRIPE = "Stripe_PaymentIntents",
  WORLD_PAY_JSON = "WorldPay_Json"
}
